import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/[locale]/login/client.tsx");
